module.exports = __webpack_public_path__ + "media/images/logo/logo-white-vertical-4e3a69b187f443376732b70b9b7ce390.svg";